// use the amplify API to make a request against quizRestAPI /public/hubspot with the user object

//import { API } from 'aws-amplify';
import { User } from '../types';
/*
export const submitUserToHubspot = async (user: User, complete: boolean) => {
  return await API.post('quizRestAPI', '/public/hubspot/create-user', {
    body: { ...user, complete }
  });
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number) => {
  const complete: boolean = true;
  return await API.post('quizRestAPI', '/public/hubspot/save-goal-time', {
    body: { ...user,complete,timeToGoal }
  });
}

*/
export type UserHubspotResponse = {
  userId: string;
};


export const submitUserToHubspot = async (user: User, complete: boolean, pricingVariant?: string) => {
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/create-user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...user,
      complete,
      ...(pricingVariant ? { pricing_variant: pricingVariant } : {}),
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
    return data.userId;
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number, pricingVariant?: string) => {
  const complete = true;
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/save-goal-time', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...user,
      weight: {
        weightRaw: user.weight,
      },
      goalWeight: {
        goalWeightRaw: user.goalWeight,
      },
      complete,
      timeToGoal,
      ...(pricingVariant ? { pricing_variant: pricingVariant } : {}),
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
  return data.userId;
}
